// With React Router

import PostCard from "./heroPostCard";
import { Link } from "react-router-dom";
import classes from "./postCard.module.css";
import posts from "./postData";
const parseDate = (dateStr) => new Date(dateStr.replace("Posted on ", ""));

const PostList = () => {

const topTwoPosts = posts
      .sort((a, b) => parseDate(b.date) - parseDate(a.date))
      .slice(0, 2);

  return (
    <>
      <div className={classes.PostContainer}>
        <div className={classes.postcardContainer}>
          <p className={classes.titlePost}>Tech POV</p>
          {topTwoPosts.map((post) => (
            <PostCard
              key={post.id}
              id={post.id}
              imageUrl={post.imageUrl}
              date={post.date}
              title={post.title}
              description={post.description}
            />
          ))}

          <Link  to="/VivekSharma/tech-pov" className={classes.postMoreButton}>
            <p className={classes.moreButton}>More on tech</p>
          </Link>
        </div>
      </div>
    </>
  );
};

export default PostList;
